<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>下游锚鞍室</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <!-- <div class="sensor1">排气夹</div>
          <div class="sensor2">进气夹</div> -->
          <div class="sensor-source">数据来源: WINCC</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">华坪</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">丽江</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-anchor-left" content="华坪下游锚室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationAnchorPlc/huaping"></router-link>
          </el-tooltip>
          <div class="stati ex1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "华坪下游锚室",
                    humidityTooltipErrorAnchorHuapingDown,
                    humidityAllowedMaxAnchorHuapingDown,
                    runningAnchorHuapingDown,
                    malfunctionAnchorHuapingDown
                  )
                }}
              </div>
              <div :class="errorAnchorHuapingDown" class="state-info right-pos" @dblclick="hrefToStation('')">
                <p>华坪下游锚室</p>
                <p>
                  <span>{{ humidityAnchorHuapingDown | toFixed }}% {{ temperatureAnchorHuapingDown | toFixed }}°C</span>
                  <span :class="runningClassAnchorHuapingDown" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-anchor-right" content="丽江下游锚室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationAnchorPlc/Lijiang"></router-link>
          </el-tooltip>
          <div class="stati ex15">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "丽江下游锚室",
                    humidityTooltipErrorAnchorLijiangDown,
                    humidityAllowedMaxAnchorLijiangDown,
                    runningAnchorLijiangDown,
                    malfunctionAnchorLijiangDown
                  )
                }}
              </div>
              <div :class="errorAnchorLijiangDown" class="state-info left-pos" @dblclick="hrefToStation('')">
                <p>丽江下游锚室</p>
                <p>
                  <span>{{ humidityAnchorLijiangDown | toFixed }}% {{ temperatureAnchorLijiangDown | toFixed }}°C</span>
                  <span :class="runningClassAnchorLijiangDown" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-saddle-left" content="华坪下游鞍室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationSaddlePlc/huaping"></router-link>
          </el-tooltip>
          <div class="stati ex3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "华坪下游鞍室",
                    humidityTooltipErrorSaddleHuapingDown,
                    humidityAllowedMaxSaddleHuapingDown,
                    runningSaddleHuapingDown,
                    malfunctionSaddleHuapingDown
                  )
                }}
              </div>
              <div :class="errorSaddleHuapingDown" class="state-info bottom-pos" @dblclick="hrefToStation('')">
                <p>华坪下游鞍室</p>
                <p>
                  <span>{{ humiditySaddleHuapingDown | toFixed }}% {{ temperatureSaddleHuapingDown | toFixed }}°C</span>
                  <span :class="runningClassSaddleHuapingDown" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-saddle-right" content="丽江下游鞍室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationSaddlePlc/Lijiang"></router-link>
          </el-tooltip>
          <div class="stati ex2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "丽江下游鞍室",
                    humidityTooltipErrorSaddleLijiangDown,
                    humidityAllowedMaxSaddleLijiangDown,
                    runningSaddleLijiangDown,
                    malfunctionSaddleLijiangDown
                  )
                }}
              </div>
              <div :class="errorSaddleLijiangDown" class="state-info bottom-pos" @dblclick="hrefToStation('')">
                <p>丽江下游鞍室</p>
                <p>
                  <span>{{ humiditySaddleLijiangDown | toFixed }}% {{ temperatureSaddleLijiangDown | toFixed }}°C</span>
                  <span :class="runningClassSaddleLijiangDown" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>上游锚鞍室</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <!-- <div class="sensor1">排气夹</div>
          <div class="sensor2">进气夹</div> -->
          <div class="sensor-source">数据来源: WINCC</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">华坪</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">丽江</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-anchor-left" content="华坪上游锚室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationAnchorPlc/huaping"></router-link>
          </el-tooltip>
          <div class="stati ex1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "华坪上游锚室",
                    humidityTooltipErrorAnchorHuapingUp,
                    humidityAllowedMaxAnchorHuapingUp,
                    runningAnchorHuapingUp,
                    malfunctionAnchorHuapingUp
                  )
                }}
              </div>
              <div :class="errorAnchorHuapingUp" class="state-info right-pos" @dblclick="hrefToStation('')">
                <p>华坪上游锚室</p>
                <p>
                  <span>{{ humidityAnchorHuapingUp | toFixed }}% {{ temperatureAnchorHuapingUp | toFixed }}°C</span>
                  <span :class="runningClassAnchorHuapingUp" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-anchor-right" content="丽江上游锚室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationAnchorPlc/Lijiang"></router-link>
          </el-tooltip>
          <div class="stati ex15">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "丽江上游锚室",
                    humidityTooltipErrorAnchorLijiangUp,
                    humidityAllowedMaxAnchorLijiangUp,
                    runningAnchorLijiangUp,
                    malfunctionAnchorLijiangUp
                  )
                }}
              </div>
              <div :class="errorAnchorLijiangUp" class="state-info left-pos" @dblclick="hrefToStation('')">
                <p>丽江上游锚室</p>
                <p>
                  <span>{{ humidityAnchorLijiangUp | toFixed }}% {{ temperatureAnchorLijiangUp | toFixed }}°C</span>
                  <span :class="runningClassAnchorLijiangUp" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-saddle-left" content="华坪上游鞍室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationSaddlePlc/huaping"></router-link>
          </el-tooltip>
          <div class="stati ex3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "华坪上游鞍室",
                    humidityTooltipErrorSaddleHuapingUp,
                    humidityAllowedMaxSaddleHuapingUp,
                    runningSaddleHuapingUp,
                    malfunctionSaddleHuapingUp
                  )
                }}
              </div>
              <div :class="errorSaddleHuapingUp" class="state-info bottom-pos" @dblclick="hrefToStation('')">
                <p>华坪上游鞍室</p>
                <p>
                  <span>{{ humiditySaddleHuapingUp | toFixed }}% {{ temperatureSaddleHuapingUp | toFixed }}°C</span>
                  <span :class="runningClassSaddleHuapingUp" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-saddle-right" content="丽江上游鞍室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationSaddlePlc/Lijiang"></router-link>
          </el-tooltip>
          <div class="stati ex2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "丽江上游鞍室",
                    humidityTooltipErrorSaddleLijiangUp,
                    humidityAllowedMaxSaddleLijiangUp,
                    runningSaddleLijiangUp,
                    malfunctionSaddleLijiangUp
                  )
                }}
              </div>
              <div :class="errorSaddleLijiangUp" class="state-info bottom-pos" @dblclick="hrefToStation('')">
                <p>丽江上游鞍室</p>
                <p>
                  <span>{{ humiditySaddleLijiangUp | toFixed }}% {{ temperatureSaddleLijiangUp | toFixed }}°C</span>
                  <span :class="runningClassSaddleLijiangUp" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      //humidity, temperature
      humidityAnchorHuapingUp: "--",
      humidityAnchorHuapingDown: "--",
      humidityAnchorLijiangUp: "--",
      humidityAnchorLijiangDown: "--",
      humiditySaddleHuapingUp: "--",
      humiditySaddleHuapingDown: "--",
      humiditySaddleLijiangUp: "--",
      humiditySaddleLijiangDown: "--",

      temperatureAnchorHuapingUp: "--",
      temperatureAnchorHuapingDown: "--",
      temperatureAnchorLijiangUp: "--",
      temperatureAnchorLijiangDown: "--",
      temperatureSaddleHuapingUp: "--",
      temperatureSaddleHuapingDown: "--",
      temperatureSaddleLijiangUp: "--",
      temperatureSaddleLijiangDown: "--",

      //running
      runningAnchorHuapingUp: "--",
      runningAnchorHuapingDown: "--",
      runningAnchorLijiangUp: "--",
      runningAnchorLijiangDown: "--",
      runningSaddleHuapingUp: "--",
      runningSaddleHuapingDown: "--",
      runningSaddleLijiangUp: "--",
      runningSaddleLijiangDown: "--",

      //malfunction
      malfunctionAnchorHuapingUp: "--",
      malfunctionAnchorHuapingDown: "--",
      malfunctionAnchorLijiangUp: "--",
      malfunctionAnchorLijiangDown: "--",
      malfunctionSaddleHuapingUp: "--",
      malfunctionSaddleHuapingDown: "--",
      malfunctionSaddleLijiangUp: "--",
      malfunctionSaddleLijiangDown: "--",

      //error
      errorSaddleLijiangUp: "--",
      errorSaddleLijiangDown: "--",
      errorSaddleHuapingUp: "--",
      errorSaddleHuapingDown: "--",
      errorAnchorLijiangUp: "--",
      errorAnchorLijiangDown: "--",
      errorAnchorHuapingUp: "--",
      errorAnchorHuapingDown: "--",

      //running class
      runningClassAnchorHuapingUp: "--",
      runningClassAnchorHuapingDown: "--",
      runningClassAnchorLijiangUp: "--",
      runningClassAnchorLijiangDown: "--",
      runningClassSaddleHuapingUp: "--",
      runningClassSaddleHuapingDown: "--",
      runningClassSaddleLijiangUp: "--",
      runningClassSaddleLijiangDown: "--",

      //humidity allowed max
      humidityAllowedMaxAnchorHuapingUp: "--",
      humidityAllowedMaxAnchorHuapingDown: "--",
      humidityAllowedMaxAnchorLijiangUp: "--",
      humidityAllowedMaxAnchorLijiangDown: "--",
      humidityAllowedMaxSaddleHuapingUp: "--",
      humidityAllowedMaxSaddleHuapingDown: "--",
      humidityAllowedMaxSaddleLijiangUp: "--",
      humidityAllowedMaxSaddleLijiangDown: "--",

      //humidity tooltip error
      humidityTooltipErrorAnchorHuapingUp: "--",
      humidityTooltipErrorAnchorHuapingDown: "--",
      humidityTooltipErrorAnchorLijiangUp: "--",
      humidityTooltipErrorAnchorLijiangDown: "--",
      humidityTooltipErrorSaddleHuapingUp: "--",
      humidityTooltipErrorSaddleHuapingDown: "--",
      humidityTooltipErrorSaddleLijiangUp: "--",
      humidityTooltipErrorSaddleLijiangDown: "--",

      dataNameIdDict: {
        //humidity, temperature
        humidityAnchorHuapingUp: "5c2dab2d-f45e-45ea-9da4-8b398b114b28",
        humidityAnchorHuapingDown: "d4e84dcb-b8f3-442b-8984-0946a0d0e9f5",
        humidityAnchorLijiangUp: "719d1f76-5a17-4b34-ad9f-affbc312ee98",
        humidityAnchorLijiangDown: "b5269f1c-e44e-4e2c-a035-5c69b4523fe8",
        humiditySaddleHuapingUp: "4002431e-8b97-459a-9e4b-5454e143023b",
        humiditySaddleHuapingDown: "f4eed4a2-c3b2-41e0-87d0-f83c0c078f73",
        humiditySaddleLijiangUp: "79e95616-000b-4c13-8b80-52eb48f5228b",
        humiditySaddleLijiangDown: "8b315c32-2871-4c97-b6bf-e2430b9166f4",

        temperatureAnchorHuapingUp: "c122b9fc-728d-4637-a05e-aec74ab83c33",
        temperatureAnchorHuapingDown: "b0d741f7-ac2b-413d-b14a-59a379da5a0a",
        temperatureAnchorLijiangUp: "3ea05222-c56e-4853-abd6-46a4c3e7c2ab",
        temperatureAnchorLijiangDown: "905b6ad8-2635-431b-9cdd-022d8847e08d",
        temperatureSaddleHuapingUp: "e89264d0-f690-4357-ac52-83f2c2e09d33",
        temperatureSaddleHuapingDown: "726dd1f0-a938-4ef8-a36d-a30b60a188b4",
        temperatureSaddleLijiangUp: "7e6e762a-8b6f-4df0-8ecb-cf93c3178154",
        temperatureSaddleLijiangDown: "92225508-7745-4266-bc1a-6a1871c3492f",

        //running
        runningAnchorHuapingUp: "72a78f89-7b67-4b99-add5-bc9a41479f8b",
        runningAnchorHuapingDown: "6dff3e48-a93f-448b-8ca1-727786cd9dfa",
        runningAnchorLijiangUp: "b7ecb9c2-0fe2-4aca-b9e6-28d9f2194ddf",
        runningAnchorLijiangDown: "0a6bb24b-6367-4272-b0d4-50c75b6344d6",
        runningSaddleHuapingUp: "56227bbd-095b-4be9-b156-245bbf8535f3",
        runningSaddleHuapingDown: "a1c0da5a-4229-450f-b7cc-20f1d9d63e99",
        runningSaddleLijiangUp: "df087d58-7133-4fb3-a864-73a491afcaaa",
        runningSaddleLijiangDown: "7e4b7ae5-7af5-4dc4-bc45-db687fe8bdd7",

        //malfunction
        malfunctionAnchorHuapingUp: "de03c625-98c6-4022-bfed-a3ebf993e188",
        malfunctionAnchorHuapingDown: "ac9baa1d-55f5-484e-afc6-55128767b665",
        malfunctionAnchorLijiangUp: "1945ac01-4771-4796-b397-24e5544fa161",
        malfunctionAnchorLijiangDown: "374f45bb-7ae4-4309-8214-a8fd93f23cc6",
        malfunctionSaddleHuapingUp: "b205f5df-4f86-4374-972d-00f4495c6719",
        malfunctionSaddleHuapingDown: "2eb29923-8129-4a82-b94c-3ff1b0e081cb",
        malfunctionSaddleLijiangUp: "c2833409-c1c5-467a-bf88-95b32e57722b",
        malfunctionSaddleLijiangDown: "79e2c532-a478-439f-9afc-fd46532f32b7",
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {},

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        humidityAnchorHuapingUp: "errorAnchorHuapingUp",
        humidityAnchorHuapingDown: "errorAnchorHuapingDown",
        humidityAnchorLijiangUp: "errorAnchorLijiangUp",
        humidityAnchorLijiangDown: "errorAnchorLijiangDown",
        humiditySaddleHuapingUp: "errorSaddleHuapingUp",
        humiditySaddleHuapingDown: "errorSaddleHuapingDown",
        humiditySaddleLijiangUp: "errorSaddleLijiangUp",
        humiditySaddleLijiangDown: "errorSaddleLijiangDown",

        temperatureAnchorHuapingUp: "errorAnchorHuapingUp",
        temperatureAnchorHuapingDown: "errorAnchorHuapingDown",
        temperatureAnchorLijiangUp: "errorAnchorLijiangUp",
        temperatureAnchorLijiangDown: "errorAnchorLijiangDown",
        temperatureSaddleHuapingUp: "errorSaddleHuapingUp",
        temperatureSaddleHuapingDown: "errorSaddleHuapingDown",
        temperatureSaddleLijiangUp: "errorSaddleLijiangUp",
        temperatureSaddleLijiangDown: "errorSaddleLijiangDown",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {
        malfunctionAnchorHuapingUp: "errorAnchorHuapingUp",
        malfunctionAnchorHuapingDown: "errorAnchorHuapingDown",
        malfunctionAnchorLijiangUp: "errorAnchorLijiangUp",
        malfunctionAnchorLijiangDown: "errorAnchorLijiangDown",
        malfunctionSaddleHuapingUp: "errorSaddleHuapingUp",
        malfunctionSaddleHuapingDown: "errorSaddleHuapingDown",
        malfunctionSaddleLijiangUp: "errorSaddleLijiangUp",
        malfunctionSaddleLijiangDown: "errorSaddleLijiangDown",
      },

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humidityAnchorHuapingUp: "humidityTooltipErrorAnchorHuapingUp",
        humidityAnchorHuapingDown: "humidityTooltipErrorAnchorHuapingDown",
        humidityAnchorLijiangUp: "humidityTooltipErrorAnchorLijiangUp",
        humidityAnchorLijiangDown: "humidityTooltipErrorAnchorLijiangDown",
        humiditySaddleHuapingUp: "humidityTooltipErrorSaddleHuapingUp",
        humiditySaddleHuapingDown: "humidityTooltipErrorSaddleHuapingDown",
        humiditySaddleLijiangUp: "humidityTooltipErrorSaddleLijiangUp",
        humiditySaddleLijiangDown: "humidityTooltipErrorSaddleLijiangDown",
      },

      //running -> running class
      dataNameRunningClassNameDict: {
        runningAnchorHuapingUp: "runningClassAnchorHuapingUp",
        runningAnchorHuapingDown: "runningClassAnchorHuapingDown",
        runningAnchorLijiangUp: "runningClassAnchorLijiangUp",
        runningAnchorLijiangDown: "runningClassAnchorLijiangDown",
        runningSaddleHuapingUp: "runningClassSaddleHuapingUp",
        runningSaddleHuapingDown: "runningClassSaddleHuapingDown",
        runningSaddleLijiangUp: "runningClassSaddleLijiangUp",
        runningSaddleLijiangDown: "runningClassSaddleLijiangDown",
      },

      //station id list
      stationIdList: [
        "6015a418-b7b1-497f-b1de-a9aa65e47891",
        "994ba00b-ce96-45fb-949b-2b505cc870d3",
        "ec951680-cab7-45c9-8406-35eee2cfb716",
        "6aea0e2d-41bd-4dd3-b481-14cd7ca2f589",
        "ada15150-d814-4526-baa2-f2a8ff5d38c7",
        "7b409dd1-4e96-4061-b8cf-8a7d87f1f5f0",
        "8ff543c4-b47f-4b38-a67b-7ac2f4e84d19",
        "93148943-41ba-411b-b091-aafd59f4ba59",
      ],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      //device id not set (device id = 'GUID') = no data
      stationData["GUID"] = {
        dataId: null,
        deviceId: "GUID",
        value: null,
        createdDate: "0001-01-01T00:00:00",
        dataDate: "0001-01-01T00:00:00",
        dataType: "VALUE",
        errorLevel: "Warning",
      };

      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if (
        (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
        allowedMax !== undefined &&
        allowedMax !== null &&
        !isNaN(parseInt(allowedMax))
      ) {
        if (allowedMax === 0) {
          result += "(无限制)";
        } else {
          result += "(<" + allowedMax + "%RH)";
        }
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel.toLowerCase() !== "warning") {
        if (runningFlag > 0) {
          result += ", 除湿机运行";
        } else if (runningFlag === 0) {
          result += ", 除湿机停止";
        }
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: bold;
        font-size: 32px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1405px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 25px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
        .sensor-source {
          margin-top: 25px;
          margin-left: -30px;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 78px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1400px;
        height: 250px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/jinshajiang/bridgeLine.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .station-block-left {
          top: 122px;
          left: 173px;
        }

        .station-block-middle {
          top: 122px;
          left: 582px;
        }

        .station-block-right {
          top: 122px;
          left: 990px;
        }

        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos:before {
              left: 45%;
              top: 90%;
              transform: translate(0%, 0%);
            }
            &.bottom-pos-sta:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }
              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos:before {
              left: 45%;
              top: 90%;
              transform: translate(0%, 0%);
            }
            &.top-pos:before {
              left: 46%;
              top: -5%;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .sta-left {
          top: 130px;
          left: 173px;
          &::before {
            bottom: 30px;
            left: -35px;
            width: 80px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 69px;
            left: -16px;
          }
          .state-info {
            right: 16px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sta-left-tower {
          top: 130px;
          left: 173px;
          &::before {
            bottom: 30px;
            left: -22px;
            width: 80px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 69px;
            left: 24px;
          }
          .state-info {
            right: -149px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sta-middle {
          top: 130px;
          left: 582px;
          &::before {
            bottom: 30px;
            left: -35px;
            width: 80px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 69px;
            left: -16px;
          }
          .state-info {
            right: 16px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sta-middle-tower {
          top: 130px;
          left: 582px;
          &::before {
            bottom: 30px;
            left: -22px;
            width: 80px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 69px;
            left: 24px;
          }
          .state-info {
            right: -149px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sta-right {
          top: 130px;
          left: 990px;
          &::before {
            bottom: 30px;
            left: -35px;
            width: 80px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 69px;
            left: -16px;
          }
          .state-info {
            right: 16px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sta-right-tower {
          top: 130px;
          left: 990px;
          &::before {
            bottom: 30px;
            left: -22px;
            width: 80px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 69px;
            left: 24px;
          }
          .state-info {
            right: -149px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .station-block-anchor-left {
          top: 143px;
          left: 218px;
        }

        .station-block-anchor-right {
          top: 143px;
          left: 1205px;
        }

        .station-block-saddle-left {
          top: 70px;
          left: 380px;
        }

        .station-block-saddle-right {
          top: 70px;
          left: 968px;
        }

        .ex1 {
          top: 153px;
          left: 218px;
          &::before {
            top: -34px;
            left: -33px;
            width: 70px;
            transform: rotate(79deg);
          }
          &::after {
            top: -68px;
            left: -19px;
          }
          .state-info {
            right: 17px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex15 {
          top: 153px;
          left: 1227px;
          &::before {
            top: -34px;
            right: -33px;
            width: 70px;
            transform: rotate(-79deg);
          }

          &::after {
            top: -68px;
            right: -19px;
          }

          .state-info {
            left: 20px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex3 {
          top: 80px;
          left: 380px;

          &::before {
            top: -20px;
            left: -9px;
            width: 40px;
            transform: rotate(90deg);
          }

          &::after {
            top: -67px;
            left: -28px;
            width: 0px;
          }

          .state-info {
            right: -73px;
            top: -60px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex2 {
          top: 80px;
          left: 969px;

          &::before {
            top: -20px;
            left: -9px;
            width: 40px;
            transform: rotate(90deg);
          }

          &::after {
            top: -67px;
            left: -28px;
            width: 0px;
          }

          .state-info {
            right: -73px;
            top: -60px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex4 {
          top: 81px;
          left: 399px;
          &::before {
            bottom: 48px;
            left: -20px;
            width: 70px;
            transform: rotate(-79deg);
          }

          &::after {
            bottom: 82px;
            left: 22px;
          }

          .state-info {
            right: -130px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex5 {
          top: 100px;
          left: 455px;
          &::before {
            top: 76px;
            right: -46px;
            width: 126px;
            transform: rotate(-80deg);
          }

          &::after {
            top: 138px;
            left: -32px;
            width: 20px;
          }

          .state-info {
            right: 45px;
            top: 139px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex6 {
          top: 120px;
          left: 524px;
          &::before {
            bottom: 48px;
            left: -20px;
            width: 70px;
            transform: rotate(-79deg);
          }

          &::after {
            bottom: 82px;
            left: 22px;
          }

          .state-info {
            right: -130px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex7 {
          top: 134px;
          left: 604px;
          &::before {
            top: 63px;
            width: 100px;
            right: -33px;
            transform: rotate(-79deg);
          }

          &::after {
            top: 111px;
            left: -26px;
          }

          .state-info {
            right: 43px;
            top: 112px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex8 {
          top: 140px;
          left: 686px;
          &::before {
            top: 20px;
            left: -6px;
            width: 28px;
            transform: rotate(270deg);
          }

          &::after {
            display: none;
            left: 21px;
          }

          .state-info {
            left: 50%;
            top: 35px;
            transform: translateX(-49%);
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex9 {
          top: 130px;
          left: 769px;
          &::before {
            top: 63px;
            width: 100px;
            left: -33px;
            transform: rotate(79deg);
          }

          &::after {
            top: 111px;
            left: 27px;
          }

          .state-info {
            left: 44px;
            top: 112px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex10 {
          top: 121px;
          left: 835px;
          &::before {
            bottom: 48px;
            right: -18px;
            width: 70px;
            transform: rotate(79deg);
          }

          &::after {
            top: -68px;
            left: -22px;
          }

          .state-info {
            right: 35px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex11 {
          top: 100px;
          left: 910px;
          &::before {
            top: 79px;
            left: -46px;
            width: 133px;
            transform: rotate(80deg);
          }

          &::after {
            bottom: -130px;
            left: 33px;
          }

          .state-info {
            left: 50px;
            top: 145px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }
        .ex12 {
          top: 81px;
          left: 958px;

          &::before {
            top: -33px;
            left: -38px;
            width: 70px;
            transform: rotate(71deg);
          }

          &::after {
            top: -67px;
            left: -28px;
          }

          .state-info {
            right: 41px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex13 {
          top: 81px;
          left: 988px;
          &::before {
            bottom: 48px;
            left: -20px;
            width: 70px;
            transform: rotate(-79deg);
          }

          &::after {
            bottom: 82px;
            left: 22px;
          }

          .state-info {
            right: -130px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex14 {
          top: 118px;
          left: 1090px;
          &::before {
            top: 70px;
            width: 116px;
            left: -44px;
            transform: rotate(82deg);
          }

          &::after {
            bottom: -112px;
            left: 23px;
          }

          .state-info {
            left: 40px;
            top: 127px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }
      }
    }
  }
}
</style>
